import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthApiService } from 'src/app/core/services/auth-api-service';
declare var bootstrap: any;
declare const google: any;
declare const FB: any;

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  
  @Input() isJobApply: boolean=false;
  isLoading: boolean = false;
  email: string = '';
  password: string = '';
  showPassword: boolean = false;
  
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });
  constructor(private translate: TranslateService, private authApiService: AuthApiService, private router: Router) {
    this.translate.setDefaultLang('esmx');
  }
  ngOnInit(): void {
    //   throw new Error('Method not implemented.');
    this.loginForm.markAllAsTouched();

    google.accounts.id.initialize({
      client_id: '936419064329-6dghpamfu760qsefqdh64030sjn08cle.apps.googleusercontent.com',
      callback: this.handleCredentialResponse.bind(this)
    });
    google.accounts.id.renderButton(
      document.getElementById("googleBtn"),
      { theme: "outline", size: "large" }
    );

    // Facebook
    (window as any)['fbAsyncInit'] = function() {
      FB.init({
        appId: '1357242225563548',
        cookie: true,
        xfbml: true,
        version: 'v19.0'
      });
    };
  }

  facebookOAuthUrl = `https://www.facebook.com/v19.0/dialog/oauth?client_id=1357242225563548&redirect_uri=http://localhost:4200/auth/facebook/callback&scope=email,public_profile`;
  facebookLogin() {
    FB.login((response: any) => {
      if (response.authResponse) {
        console.log('Token: ', response.authResponse.accessToken);
        console.log('User ID: ', response.authResponse.userID);
        this.getUserData();
      } else {
        console.error('El usuario canceló el login o no autorizó.');
      }
    }, { scope: 'public_profile,email' });
  }

  getUserData() {
    FB.api('/me', { fields: 'name,email,picture' }, (response: any) => {
      console.log('Información del usuario: ', response);
      // Aquí puedes guardar el usuario o enviar al backend
    });
  }

  //Google
  handleCredentialResponse(response: any) {
    console.log(response.credential); // Aquí tienes el JWT del usuario
  }

  login2() {
    if (this.authApiService.login2(this.email)) {
      if(!this.isJobApply){

        this.router.navigate(['/']).then(() => {
          window.location.reload();  // 🔄 Forzar recarga si es necesario
        });
      }else{
        this.router.navigate([]).then(() => {
          window.location.reload();  // 🔄 Forzar recarga si es necesario
        });
      }
    } else {
      this.showErrorModal();
    }
  }

  login() {
    // Validar que el formulario sea válido
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    // Validar campos básicos
    if (this.email.trim() === '' || this.password.trim() === '') {
      this.showErrorModal();
      return;
    }

    this.authApiService.login2(this.email, this.password).subscribe((res: any) => {
      if (res && !res.error && !res.invalidCredentials) {
        localStorage.setItem('candidatoId', res?.candidatoId || res?.id);
        if(!this.isJobApply){
          this.router.navigate(['/']).then(() => {
            window.location.reload();  // 🔄 Forzar recarga si es necesario
          });
        }else{
          this.router.navigate([]).then(() => {
            window.location.reload();  // 🔄 Forzar recarga si es necesario
          });
        }
      } else {
        // Si hay un mensaje de error específico, mostrarlo
        if (res?.message) {
          this.showErrorModal(res.message);
        } else {
          this.showErrorModal();
        }
      }
    }, (err: any) => {
        this.showErrorModal();
    });

    /*this.authApiService.recuperaCandidatoId(this.email).subscribe((response: any) => {
      if (response?.error) {
        
      } else {
        this.showErrorModal();
      }
    },(err: any) => {
         this.showErrorModal();
    });*/
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
  
  errorMessage: string = 'No pudimos iniciar tu sesión. Verifica que tu usuario y contraseña sean correctos. Si el problema persiste, ponte en contacto con nosotros.';

  showErrorModal(customMessage?: string) {
    if (customMessage) {
      this.errorMessage = customMessage;
    } else {
      this.errorMessage = 'No pudimos iniciar tu sesión. Verifica que tu usuario y contraseña sean correctos. Si el problema persiste, ponte en contacto con nosotros.';
    }
    const modalElement = document.getElementById('errorModal');
    if (modalElement) {
      const errorModal = new bootstrap.Modal(modalElement);
      errorModal.show();
    }
  }
}
